import { GamificationStatus } from '@/@types/gamification';

export const STATUS_MAP: Record<string, GamificationStatus> = {
  'ACTIVE': GamificationStatus.ATIVA,
  'INACTIVE': GamificationStatus.INATIVA,
  'SCHEDULED': GamificationStatus.AGENDADA,
  'ENDED': GamificationStatus.ENCERRADA,
  'FINISHED': GamificationStatus.ENCERRADA,
  'DRAFT': GamificationStatus.RASCUNHO,
  'RASCUNHO': GamificationStatus.RASCUNHO,
} as const;

export function mapStatusToFrontend(
  backendStatus: string,
  deletedAt: string | null
): GamificationStatus {
  if (deletedAt) {
    return GamificationStatus.INATIVA;
  }

  const normalizedStatus = backendStatus?.toUpperCase();
  const mappedStatus = STATUS_MAP[normalizedStatus];

  return mappedStatus ?? GamificationStatus.ENCERRADA;
}
